import { jwtDecode } from 'jwt-decode';
import { EstimateResponse } from '@/types/estimates/EstimateResponse';

/** True when the estimate is opened via the tour-operator agency link (Lien 1). */
export const resolveIsAgencyLinkView = (
  estimate: Pick<EstimateResponse, 'viewContext' | 'sharedLinkType'>,
  accessToken?: string,
): boolean => {
  if (estimate.viewContext === 'AGENCY_LINK') return true;
  if (estimate.sharedLinkType === 'AGENCY') return true;
  if (!accessToken) return false;
  try {
    const payload = jwtDecode<{ linkType?: 'AGENCY' | 'CLIENT' }>(accessToken);
    return payload.linkType === 'AGENCY';
  } catch {
    return false;
  }
};
